import type { SimKey } from 'types/common';
import { type ColumnDef } from '../SimInventoryTableShared';
import ActiveProfileIccidRenderer from './ActiveProfileIccidRenderer';
import ByteRenderer from './ByteRenderer';
import DateRenderer from './DateRenderer';
import DeviceNameRenderer from './DeviceNameRenderer';
import DurationRenderer from './DurationRenderer';
import IMEIRenderer from './IMEIRenderer';
import OrganizationRenderer from './OrganizationRenderer';
import SimStatusRenderer from './SimStatusRenderer';

export type SimColumn = ColumnDef<SimKey | 'checkbox' | any>;

export const CheckboxSelect: SimColumn = {
  name: 'Checkbox',
  width: 36,
  value: 'checkbox',
  nullsHigher: false,
};

export const DeviceName: SimColumn = {
  name: 'Name',
  width: 240,
  value: 'deviceName',
  renderer: DeviceNameRenderer,
  nullsHigher: false,
};

export const SIMStatus: SimColumn = {
  name: 'SIM status',
  width: 120,
  value: 'networkState',
  nullsHigher: false,
  renderer: SimStatusRenderer,
};

export const BootstrapIccid: SimColumn = {
  name: 'Bootstrap profile ICCID',
  width: 170,
  value: 'bootstrapProfileIccid',
  nullsHigher: false,
};

export const ActiveProfileIccid: SimColumn = {
  name: 'Enabled profile ICCID',
  width: 200,
  value: 'activeProfileIccid',
  renderer: ActiveProfileIccidRenderer,
  nullsHigher: false,
  numeric: true,
};

export const Imei: SimColumn = {
  name: 'Last known IMEI',
  width: 140,
  value: 'imei',
  renderer: IMEIRenderer,
  nullsHigher: false,
  numeric: true,
};

export const DeviceId: SimColumn = {
  name: 'Device ID',
  width: 80,
  value: 'deviceId',
  nullsHigher: false,
  numeric: true,
};

export const DataPlan: SimColumn = {
  name: 'Data plan',
  width: 260,
  value: 'planName',
  nullsHigher: false,
};

export const DeactivatedDate: SimColumn = {
  name: 'Deactivated date (UTC)',
  width: 120,
  value: 'deactivationTime',
  rightAligned: true,
  nullsHigher: false,
  renderer: DateRenderer,
  numeric: true,
};

export const DeactivatedBy: SimColumn = {
  name: 'Deactivated by',
  width: 120,
  nullsHigher: false,
  value: 'deactivatedBy',
};

export const ActivationDate: SimColumn = {
  name: 'Activation date (UTC)',
  width: 120,
  value: 'activationTime',
  rightAligned: true,
  nullsHigher: false,
  renderer: DateRenderer,
  numeric: true,
};

export const TestConfig: SimColumn = {
  name: 'Test config',
  width: 120,
  value: 'preflightExitBehavior',
  nullsHigher: false,
};

export const Configuration: SimColumn = {
  name: 'Configuration',
  width: 120,
  value: 'preflightExitBehavior',
  nullsHigher: false,
};

export const OrgName: SimColumn = {
  name: 'Organization',
  width: 200,
  value: 'organizationName',
  nullsHigher: false,
  renderer: OrganizationRenderer,
};

export const ProfileName: SimColumn = {
  name: 'Profile name',
  width: 120,
  value: 'profileName',
  nullsHigher: false,
};

export const SimId: SimColumn = {
  name: 'SIM ID',
  width: 80,
  value: 'hologramSimId',
  nullsHigher: false,
  numeric: true,
};

export const LastActive: SimColumn = {
  name: 'Last closed session',
  width: 90,
  value: 'mostRecentSession',
  nullsHigher: false,
  renderer: DurationRenderer,
  numeric: true,
};

export const BillingPeriodUsage: SimColumn = {
  name: 'Data usage',
  width: 90,
  value: 'billingPeriodUsage',
  nullsHigher: false,
  rightAligned: true,
  renderer: ByteRenderer,
  numeric: true,
};

export const PreflightUsage: SimColumn = {
  name: 'Data usage',
  width: 90,
  value: 'preflightUsage',
  nullsHigher: false,
  rightAligned: true,
  renderer: ByteRenderer,
  numeric: true,
};

export const AllPreflightUsage: SimColumn = {
  name: 'Preflight usage',
  width: 90,
  value: 'preflightUsage',
  nullsHigher: false,
  rightAligned: true,
  renderer: ByteRenderer,
  numeric: true,
};

export const ExpectedActivationDate: SimColumn = {
  name: 'Target activation date',
  width: 120,
  value: 'expectedActivationTime',
  nullsHigher: true,
  renderer: DateRenderer,
  numeric: true,
};
